var option_webview_default = {
  "option": "gXPUs",
  "user_choice": "um7Ms",
  "check": "o8l-k",
  "image": "wiWTs",
  "input": "pJ5Ir",
  "title": "jfUmz",
  "centered": "EkjMu",
  "with_result": "wrcG5",
  "list": "FvK3-",
  "with_image": "lP7bG",
  "progress": "Kdn1a",
  "progress_value": "M7cVW",
  "label": "pOUob",
  "cta": "_870je",
  "adornment_icon": "O03Gf",
  "remove": "N0D-L",
  "removeButton": "iw1wU",
  "removeButtonIcon": "XqMfS",
  "overlay": "tqJJl",
  "shown": "nuD-h",
  "dark": "FvvZR",
  "spinner": "EaBUG",
  "spin": "Bakzr",
  "grid": "Tz49G"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
